"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GENERAL = exports.TEMPORARY_REMOTE_TOOLS = exports.BUNDLE = exports.ENTERPRISE = exports.SUITE_ENTERPRISE = exports.SUITE_PROFESSIONAL = exports.SUITE_STARTER = exports.PARTNER_PROGRAM = exports.SERVICE_FREE = exports.MARKETING_FREE = exports.SALES_FREE = exports.CRM = exports.CMS_PROFESSIONAL = exports.CMS_ENTERPRISE = exports.CMS = exports.TECHNICAL_CONSULTING_BLOCK = exports.INBOUND_CONSULTING_BLOCK = exports.SERVICE_PROFESSIONAL_ONBOARDING = exports.SALES_PROFESSIONAL_ONBOARDING = exports.STARTER_KIT = exports.IN_PERSON_TRAINING = exports.DESIGNATED_TECHNICAL_SUPPORT = exports.CUSTOM_SSL = exports.LISTS_ADDON = exports.WORKFLOWS_ADDON = exports.BRAND_DOMAIN = exports.ADDITIONAL_ACCOUNT = exports.TRANSACTIONAL_EMAIL = exports.DEDICATED_IP = exports.REPORTING = exports.WEBSITE = exports.ADS_CAPACITY = exports.ADS = exports.STARTER_CONTACTS = exports.SERVICE_ENTERPRISE = exports.SERVICE_PROFESSIONAL = exports.SERVICE_STARTER = exports.SERVICE = exports.MARKETING_ENTERPRISE = exports.MARKETING_PRO = exports.MARKETING_BASIC = exports.MARKETING_STARTER_EMAIL = exports.MARKETING_STARTER = exports.MARKETING = exports.SALES_ENTERPRISE = exports.SALES_PROFESSIONAL = exports.SALES_STARTER = exports.SALES_PRO = exports.SALES = void 0;
var SALES = 'sales';
exports.SALES = SALES;
var SALES_PRO = 'sales-pro';
exports.SALES_PRO = SALES_PRO;
var SALES_STARTER = 'sales-starter';
exports.SALES_STARTER = SALES_STARTER;
var SALES_PROFESSIONAL = 'sales-professional';
exports.SALES_PROFESSIONAL = SALES_PROFESSIONAL;
var SALES_ENTERPRISE = 'sales-enterprise';
exports.SALES_ENTERPRISE = SALES_ENTERPRISE;
var MARKETING = 'marketing';
exports.MARKETING = MARKETING;
var MARKETING_STARTER = 'marketing-starter';
exports.MARKETING_STARTER = MARKETING_STARTER;
var MARKETING_STARTER_EMAIL = 'marketing-starter-email';
exports.MARKETING_STARTER_EMAIL = MARKETING_STARTER_EMAIL;
var MARKETING_BASIC = 'marketing-basic';
exports.MARKETING_BASIC = MARKETING_BASIC;
var MARKETING_PRO = 'marketing-pro';
exports.MARKETING_PRO = MARKETING_PRO;
var MARKETING_ENTERPRISE = 'marketing-enterprise';
exports.MARKETING_ENTERPRISE = MARKETING_ENTERPRISE;
var SERVICE = 'service';
exports.SERVICE = SERVICE;
var SERVICE_STARTER = 'service-starter';
exports.SERVICE_STARTER = SERVICE_STARTER;
var SERVICE_PROFESSIONAL = 'service-professional';
exports.SERVICE_PROFESSIONAL = SERVICE_PROFESSIONAL;
var SERVICE_ENTERPRISE = 'service-enterprise';
exports.SERVICE_ENTERPRISE = SERVICE_ENTERPRISE;
var STARTER_CONTACTS = 'starter-contacts';
exports.STARTER_CONTACTS = STARTER_CONTACTS;
var ADS = 'ads';
exports.ADS = ADS;
var ADS_CAPACITY = 'ads-capacity';
exports.ADS_CAPACITY = ADS_CAPACITY;
var WEBSITE = 'website';
exports.WEBSITE = WEBSITE;
var REPORTING = 'reporting';
exports.REPORTING = REPORTING;
var DEDICATED_IP = 'dedicated-ip';
exports.DEDICATED_IP = DEDICATED_IP;
var TRANSACTIONAL_EMAIL = 'transactional-email';
exports.TRANSACTIONAL_EMAIL = TRANSACTIONAL_EMAIL;
var ADDITIONAL_ACCOUNT = 'additional-account';
exports.ADDITIONAL_ACCOUNT = ADDITIONAL_ACCOUNT;
var BRAND_DOMAIN = 'brand-domain';
exports.BRAND_DOMAIN = BRAND_DOMAIN;
var WORKFLOWS_ADDON = 'workflows-addon';
exports.WORKFLOWS_ADDON = WORKFLOWS_ADDON;
var LISTS_ADDON = 'lists-addon';
exports.LISTS_ADDON = LISTS_ADDON;
var CUSTOM_SSL = 'custom-ssl';
exports.CUSTOM_SSL = CUSTOM_SSL;
var DESIGNATED_TECHNICAL_SUPPORT = 'designated-technical-support';
exports.DESIGNATED_TECHNICAL_SUPPORT = DESIGNATED_TECHNICAL_SUPPORT;
var IN_PERSON_TRAINING = 'in-person-training';
exports.IN_PERSON_TRAINING = IN_PERSON_TRAINING;
var STARTER_KIT = 'starter-kit';
exports.STARTER_KIT = STARTER_KIT;
var SALES_PROFESSIONAL_ONBOARDING = 'sales-professional-onboarding';
exports.SALES_PROFESSIONAL_ONBOARDING = SALES_PROFESSIONAL_ONBOARDING;
var SERVICE_PROFESSIONAL_ONBOARDING = 'service-professional-onboarding';
exports.SERVICE_PROFESSIONAL_ONBOARDING = SERVICE_PROFESSIONAL_ONBOARDING;
var INBOUND_CONSULTING_BLOCK = 'inbound-consulting-block';
exports.INBOUND_CONSULTING_BLOCK = INBOUND_CONSULTING_BLOCK;
var TECHNICAL_CONSULTING_BLOCK = 'technical-consulting-block';
exports.TECHNICAL_CONSULTING_BLOCK = TECHNICAL_CONSULTING_BLOCK;
var CMS = 'cms';
exports.CMS = CMS;
var CMS_ENTERPRISE = 'cms-enterprise';
exports.CMS_ENTERPRISE = CMS_ENTERPRISE;
var CMS_PROFESSIONAL = 'cms-professional'; // Used only for free product activation

exports.CMS_PROFESSIONAL = CMS_PROFESSIONAL;
var CRM = 'crm';
exports.CRM = CRM;
var SALES_FREE = 'sales-free';
exports.SALES_FREE = SALES_FREE;
var MARKETING_FREE = 'marketing-free';
exports.MARKETING_FREE = MARKETING_FREE;
var SERVICE_FREE = 'service-free'; // Used for partner-program inquiries

exports.SERVICE_FREE = SERVICE_FREE;
var PARTNER_PROGRAM = 'partner-program'; // For growth-suite purchases

exports.PARTNER_PROGRAM = PARTNER_PROGRAM;
var SUITE_STARTER = 'suite-starter';
exports.SUITE_STARTER = SUITE_STARTER;
var SUITE_PROFESSIONAL = 'suite-professional';
exports.SUITE_PROFESSIONAL = SUITE_PROFESSIONAL;
var SUITE_ENTERPRISE = 'suite-enterprise'; // Used when feature can be unlocked by any enterprise SKU

exports.SUITE_ENTERPRISE = SUITE_ENTERPRISE;
var ENTERPRISE = 'enterprise';
exports.ENTERPRISE = ENTERPRISE;
var BUNDLE = 'bundle';
exports.BUNDLE = BUNDLE;
var TEMPORARY_REMOTE_TOOLS = 'temporary-remote-tools'; // Used to designate upgrades not associated with a product
// ONLY FOR USE WITH UIContactSalesButton, see ui-addon-upgrades PR#384

exports.TEMPORARY_REMOTE_TOOLS = TEMPORARY_REMOTE_TOOLS;
var GENERAL = 'general';
exports.GENERAL = GENERAL;